import { render, staticRenderFns } from "./frameContent.vue?vue&type=template&id=3b1fc0f3&scoped=true&"
import script from "./frameContent.vue?vue&type=script&lang=js&"
export * from "./frameContent.vue?vue&type=script&lang=js&"
import style0 from "./frameContent.vue?vue&type=style&index=0&id=3b1fc0f3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1fc0f3",
  null
  
)

export default component.exports